// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__22MAA","type":"styles_type__2NRW8","choices":"styles_choices__2-zjk"};